import { driver } from "@leagueplatform/masonry";
import { MasonryVerticalLayoutRenderer } from "@leagueplatform/masonry-renderers";
import { CarePlansVerticalLayoutRenderer } from "masonry/renderers/care-plans-vertical-layout-renderer.component";

let registered = false;

export const registerEmblemCarePlansRenderers = () => {
  if (registered) return;
  registered = true;

  driver.nodeRendererRegistry.overrideRenderer(
    "verticalLayout",
    "default",
    CarePlansVerticalLayoutRenderer as unknown as typeof MasonryVerticalLayoutRenderer
  );
};
